import React, { Component } from 'react'
import { connect } from 'react-redux'
import { routerActions } from 'react-router-redux'
import PropTypes from 'prop-types'

import { blockWelcomeModal } from 'MarketPlace/shared/actions'
import Collaboration from 'MarketPlace/shared/views/CollaborationView'
import Navigation from 'Navigation/Navigation'
import { DEFISO_PORTAL } from 'MarketPlace/shared/constants/frameUrls'

import { isIOS } from 'shared/helpers/utils'

class AdvertisingCollaborationView extends Component {
  static propTypes = {
    t: PropTypes.func,
    blockWelcomeModal: PropTypes.func.isRequired,
    cancelHandler: PropTypes.func.isRequired,
    openPortalInIframe: PropTypes.func.isRequired
  }

  componentDidMount () {
    this.props.blockWelcomeModal(true)
  }

  get collaborationConfig () {
    const { t } = this.props
    return {
      message: t('advertisingCollaboration', 'message').s,
      partnerOffer: t('advertisingCollaboration', 'offers').s,
      iconName: 'defiso',
      iconType: 'png'
    }
  }

  openPortal = () => {
    const { openPortalInIframe } = this.props
    // Defiso portal has some issues when loaded in iOS iframe (anchor links doesn't work, keyboard covers input).
    // For iOS < 13 we should open portal in browser.
    // Also, all our iframes got a bug in iOS 13 https://stackoverflow.com/questions/61046560/site-dont-reset-scale-after-change-viewport-on-ios-13
    if (isIOS()) {
      window.open(DEFISO_PORTAL, '_blank')
    } else {
      openPortalInIframe()
    }
  }

  render () {
    return (
      <Collaboration
        {...this.collaborationConfig}
        {...this.props}
        startHandler={this.openPortal}
      />
    )
  }
}

const AdvertisingCollaborationWithNavigation = (props) => {
  const navBarTitle = props.t('advertisingCollaboration', 'title').s

  return (
    <div className='advertising-collaboration-wrapper'>
      <Navigation hideFooter onClickBack={props.cancelHandler} title={navBarTitle} notBottomSpace >
        <AdvertisingCollaborationView {...props} />
      </Navigation>
    </div>
  )
}

AdvertisingCollaborationWithNavigation.propTypes = {
  cancelHandler: PropTypes.func.isRequired
}

const mapStateToProps = (state) => {
  return {
    t: state.i18n.get('app', 'views', 'MarketPlace')
  }
}

function mapDispatchToProps (dispatch) {
  return {
    blockWelcomeModal: (...args) => dispatch(blockWelcomeModal(...args)),
    cancelHandler: () => dispatch(routerActions.goBack()),
    openPortalInIframe: () => dispatch(routerActions.push('/marketplace/advertising/portal'))
  }
}

export const AdvertisingCollaboration = connect(mapStateToProps, mapDispatchToProps)(AdvertisingCollaborationView)
export default connect(mapStateToProps, mapDispatchToProps)(AdvertisingCollaborationWithNavigation)
